import pb from '../lib/pb';

export async function saveSprite(opts: {
  id?: string;
  name: string;
  pixels: number[][];
  palette: string[];
  width: number;
  height: number;
  tags?: string[];
  previewBlob?: Blob;
}) {
  if (!pb.authStore.isValid) throw new Error('Not authenticated');

  const form = new FormData();
  form.append('name', opts.name);
  form.append('pixels', JSON.stringify(opts.pixels));
  form.append('palette', JSON.stringify(opts.palette));
  form.append('width', String(opts.width));
  form.append('height', String(opts.height));
  form.append('owner', pb.authStore.model?.id || ''); // viktigt för rule owner=@request.auth.id
  if (opts.tags) form.append('tags', JSON.stringify(opts.tags));
  if (opts.previewBlob) form.append('preview', opts.previewBlob, 'preview.png');

  try {
    const rec = opts.id
      ? await pb.collection('sprites').update(opts.id, form)
      : await pb.collection('sprites').create(form);
    return rec;
  } catch (e:any) {
    console.error('[spriteService] save error', e?.response || e);
    throw e;
  }
}

export async function listMySprites() {
  const records = await pb.collection('sprites').getFullList({
    sort: '-created',
  });

  return records.map(r => {
    const previewUrl = r.preview
      ? pb.files.getURL(r, r.preview, { thumb: '128x128' })
      : null;
    return {
      id: r.id,
      name: r.name,
      pixels: (r as any).pixels,
      palette: (r as any).palette,
      previewUrl,
    };
  });
}

export async function getSprite(id:string){ return await pb.collection('sprites').getOne(id); }

export async function deleteSprite(id: string) {
  return pb.collection('sprites').delete(id);
}